export const pageTitle = 'Lupa Password';
export const pageDescription = 'Masukkan email terdaftar, dan kami akan kirimkan link untuk reset password. Cek inboxmu sebentar lagi!';
export const backToPreviousPage = 'Balik ke halaman sebelumnya';

export const formForgotPassword = {
  email: {
    label: 'Email',
    placeholder: 'contoh@email.com',
  },

  button: {
    send: 'Lanjutkan',
  },
};

export const alertSuccess = {
  title: 'Cek email untuk langkah selanjutnya! 📩',
  description:
    'Instruksi untuk mengatur ulang kata sandi telah berhasil dikirimkan ke email kamu. Pastikan email kamu terdaftar dan periksa folder spam jika tidak melihat email tersebut.',
};

export const alertResend = {
  message: 'Tidak mendapat email?',
  action: 'Kirim Ulang',
};

export const alertError = {
  title: 'Terlalu banyak permintaan',
  description: 'Kamu telah meminta pengiriman ulang terlalu sering dalam waktu singkat. Silakan tunggu beberapa menit sebelum mencoba lagi.',
};
